var React = require('react');

function PFFBrandIconsThinEnter (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#022137;}\n"),React.createElement("g",{"id":"Designs","key":1},React.createElement("path",{"className":"st0","d":"M519,174.7v288c0,8.3-6.7,15-15,15H252.2l46.4,46.4l-21.2,21.2l-72-72c-5.8-5.9-5.8-15.4,0-21.2l72-72\n\t\tl21.2,21.2l-46.4,46.4H489v-273H519z"})),React.createElement("g",{"id":"Layer_2","key":2})]);
}

PFFBrandIconsThinEnter.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 720 720","style":{"enableBackground":"new 0 0 720 720"},"xmlSpace":"preserve"};

module.exports = PFFBrandIconsThinEnter;

PFFBrandIconsThinEnter.default = PFFBrandIconsThinEnter;
